import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import AsYouType, { getCountryCallingCode } from "libphonenumber-js";
import { COUNTRY_PHONE_CODE, ACCOUNT_TYPES, INDIA_ACCOUNT_TYPES, BENETYPES, EMAIL, BUSINESS_TYPES_FUNDINGlINK} from "../../appconstants";
import {
  CancelButton,
  FlexContainer,
  H1Text,
  Hr,
  Input,
  InputWrapper,
  LabelText, SpanText,
  SubmitButton,
  Text
} from "../../design";
import PaymentError from "../paymenterror";
import { ErrorMessage } from "@hookform/error-message";
import Select from "react-select";
import NumberFormat from "react-number-format";
import { isValidPhoneNumber } from 'libphonenumber-js';

type Props = {
  errorMsg: string,
  errorHeader: string,
  submit: Function,
  preFillCustomer: {
    name: string,
    email: string,
    phoneNumber: string,
  },
  headerText: string,
  buttonText: string,
  customerValidation: boolean,
  customerDisabled: boolean,
  alpha2: string,
  disableButtonText: string,
  planStartDate: Object,
  currentDateObject: Object,
  cancel: Function,
  showCancelBtn: boolean,
  cancelButtonText: string,
  transferType: String,
  issuerType: String,
}

const FundingLink = (props: Props) => {
  const { submit, preFillCustomer, customerDisabled, buttonDisabled,
    headerText, buttonText, errorHeader, errorMsg, transferType, issuerType,
    customerValidation, alpha2, disableButtonText, planStartDate, currentDateObject, showCancelBtn, cancel, cancelButtonText } = props;

  const [isShowErrorMessage, setShowErrorMessage] = useState(false);
  const BACKGROUND_COLOR = '#E8ECED';
  const COLOR = '#6A6A6A';

  const [showCancelButton, setShowCancelButton] = useState(showCancelBtn);

  useEffect(() => {
    setShowCancelButton(showCancelBtn);
  }, [showCancelBtn]);

  const {
    control,
    handleSubmit,
    errors,
    reset,
    setValue,
  } = useForm();

  useEffect(() => {
    if (preFillCustomer) {
      const phone = preFillCustomer && preFillCustomer.phoneNumber && AsYouType(preFillCustomer.phoneNumber);
      const countryCallingCode = phone && `+${phone.countryCallingCode}` || alpha2 && `+${getCountryCallingCode(alpha2)}`;
      reset({
        name: preFillCustomer && preFillCustomer.name || "",
        email: preFillCustomer && preFillCustomer.email || "",
        phone: phone && phone.nationalNumber || "",
        countryCallingCode: countryCallingCode && findCountryCallingCode(countryCallingCode) || "",
        isDefault: false,
      })
    }
  }, [reset, preFillCustomer]);

  useEffect(() => {
    if (errorMsg) {
      setShowErrorMessage(true);
    } else setShowErrorMessage(false);
  }, [errorMsg]);

  const findCountryCallingCode = (value) => (
    value && COUNTRY_PHONE_CODE.includes(value) && { value }
  );

  const phoneCustomStyles = {
    container: base => ({
      height: '41px',
      width: '100px !important',
      // maxWidth: '100px !important',
    }),
    control: base => ({
      ...base,
      height: '39px',
      minHeight: '39px',
      width: '100px !important',
      border: 'none',
      borderRight: '1px solid #CCCCCC',
      boxShadow: 'none',
      borderColor: '#CCCCCC !important',
    }),
  };

  const disableStyles = {
    container: base => ({
      height: '41px',
      width: '100px !important',
    }),
    control: base => ({
      ...base,
      height: '39px',
      minHeight: '39px',
      // width: '100px !important',
      border: 'none',
      borderRight: '1px solid #CCCCCC',
      boxShadow: 'none',
      borderColor: '#CCCCCC !important',
      background: '#E8ECED',
      color: '#6A6A6A'
    }),
  };

  const isPhoneNumberValidate = (data: string) => {
    const cuntryCode = control.getValues().countryCallingCode.value;
    const phoneNum = control.getValues().phone;
    if(!isValidPhoneNumber(`${cuntryCode}${phoneNum}`)) {
      return 'The phone number is invalid';
    }
  };

  const onSubmit = data => {
    const { name, email, phone, countryCallingCode, vpa, businessType, bankName, accountType, accountNumber,accountHolderName, routingNumber } = data;
    const phoneNumber = countryCallingCode && countryCallingCode.value && `${countryCallingCode.value}${phone}`;
    const customer = { name, email, phoneNumber };
    const BankName = bankName && bankName.trim();
    const AccountHolderName = bankName && accountHolderName.trim();
    const Route = bankName && routingNumber.trim();
    const AccountNum = bankName && accountNumber.trim();
    let beneType = BENETYPES.BANK;
    if ((issuerType === 'ICICI') || (issuerType === 'Cashfree')) {
      if (transferType === 'UPI') {
        beneType = BENETYPES.VPA;
      } else {
        beneType = BENETYPES.BANK;
      }
    }
  const paymentMethod = { bank: { bankName: BankName,accountHolderName:AccountHolderName, businessType: businessType?.value, accountType: accountType?.value === "CURRENT ACCOUNT" ? "CURRENT" : accountType?.value, accountNumber: AccountNum, routingNumber: Route } };
    const finalData = { ...data, phoneNumber, customer, paymentMethod, beneType, vpa };
    if (submit) { submit(finalData) }
  };

  const onCancel = () => { showCancelButton && cancel && cancel(); };

  const customInputStyle = {
    background: 'white',
    // color: 'black',
    borderColor: '#CCCCCC',
    width: '100%',
    height: '41px',
    paddingLeft: '15px',
  }

    const selectCustomStyles = {
    container: base => ({
      ...base,
      width: '100%',
      height: '41px',
      marginTop: '8px',
      marginBottom: '8px',
      borderRadius: '10px',
    }),
    control: base => ({
      ...base,
      height: '41px',
      minHeight: 33,
      border: '1px solid #CCCCCC',
      boxShadow: 'none',
      borderColor: '#CCCCCC !important',
    }),
    dropdownIndicator: base => ({
      ...base,
      height: 33,
      minHeight: 33,
    }),
  };

  return (
    <>
      <H1Text
        className="px-1 px-md-4 mb-0"
      >
        {headerText || "Pay With ACH"}
      </H1Text>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit(onSubmit)(e);
        }}
        onChange={() => setShowErrorMessage(false)}
        style={{
          width: '100%',
        }}
      >
        <FlexContainer
          flexDirection="column"
        >
          <div className="px-1 px-md-4 mt-2">
            <LabelText style={{ color: 'black' }}>
              Name
            </LabelText>
            <Controller
              defaultValue={""}
              color={errors.name ? "red" : "inherit"}
              marginBottom="0px"
              control={control}
              name="name"
              placeholder="Enter your name"
              rules={customerValidation && {
                required: 'This field is required'
              }}
              as={<Input
                readOnly={customerDisabled}
                style={{...customInputStyle, background: customerDisabled ? BACKGROUND_COLOR : '' }}
              />}
            />
            <ErrorMessage
              errors={errors}
              name="name"
              render={({ message }) => (
                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
              )}
            />
            <LabelText style={{ color: 'black' }}>
              E-Mail
            </LabelText>
            <Controller
              marginBottom="0px"
              defaultValue={""}
              color={errors.email ? "red" : "inherit"}
              control={control}
              name="email"
              placeholder="Enter your email address"
              rules={customerValidation && {
                required: 'This field is required',
                pattern: {
                  value: EMAIL.DEFAULT_REGEX,
                  message: 'The email is invalid',
                },
              }}
              as={<Input
                readOnly={customerDisabled}
                style={{...customInputStyle, background: customerDisabled ? BACKGROUND_COLOR : '' }}
              />}
            />
            <ErrorMessage
              errors={errors}
              name="email"
              render={({ message }) => (
                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
              )}
            />
            <LabelText style={{ color: 'black' }}>
              Phone
            </LabelText>
            <InputWrapper className="row" display="flex" marginTop="8px" style={{
              ...customInputStyle,
              paddingLeft: 0,
            }}>
              <Controller
                defaultValue={""}
                color={errors.countryCallingCode ? "red" : "inherit"}
                marginBottom="0px"
                control={control}
                name="countryCallingCode"
                placeholder="select"
                rules={customerValidation && {
                  required: 'Calling Code is required'
                }}
                as={<Select
                  className="col-4 px-0 border-0"
                  menuPlacement="auto"
                  isSearchable={!customerDisabled}
                  menuIsOpen={customerDisabled ? false : undefined}
                  theme={theme => ({
                    ...theme,
                    borderRadius: "4px 0 0 4px",
                    boxShadow: 0
                  })}
                  getOptionLabel={(option) => option.value}
                  styles={customerDisabled ? disableStyles : phoneCustomStyles}
                  options={COUNTRY_PHONE_CODE.map(value => { return { value } })} />}
              />
              <Controller
                className="col"
                defaultValue={""}
                color={errors.phone ? "red" : "inherit"}
                border="0px !important"
                marginBottom="0px"
                marginTop="0px"
                marginLeft="0px"
                paddingRight="0"
                control={control}
                name="phone"
                rules={customerValidation && {
                  required: 'This field is required',
                  validate: isPhoneNumberValidate
                }}
                as={<NumberFormat
                  type="tel"
                  allowNegative={false}
                  decimalScale={0}
                  readOnly={customerDisabled}
                  borderRadius="none"
                  style={{
                    background: customerDisabled ? BACKGROUND_COLOR : '',
                    color: customerDisabled ? COLOR : ''
                  }}
                />}
                placeholder="Enter your phone number"
                customInput={Input}
              />
            </InputWrapper>
            <ErrorMessage
              errors={errors}
              name="phone"
              render={({ message }) => (
                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
              )}
            />
            <Hr />
            {
              transferType === 'UPI' && alpha2 === 'IN' ? (
                <>
                  <LabelText>
                    UPI Id
                  </LabelText>
                  <Controller
                    defaultValue={""}
                    color={errors.vpa ? "red" : "inherit"}
                    marginBottom="0px"
                    control={control}
                    name="vpa"
                    placeholder="Enter your upi id"
                    rules={{
                      required: 'This field is required',
                      pattern: {
                        value: /^\w.+@\w+$/,
                        message: 'The upi id is invalid',
                      },
                    }}
                    as={<Input className="w-100" />}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="vpa"
                    render={({ message }) => (
                      <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                    )}
                  />
                </>
              ) : alpha2 === 'IN' ? (
                <>
                  <LabelText style={{ color: 'black' }}>Bank Name</LabelText>
                  <Controller
                    defaultValue={""}
                    color={errors.bankName ? "red" : "inherit"}
                    marginBottom="0px"
                    control={control}
                    name="bankName"
                    placeholder="Enter bank name"
                    rules={{
                      required: 'This field is required',
                      pattern: {
                        value: /^[a-zA-Z ]+$/,
                        message: 'Bank name must be valid',
                      },
                    }}
                    as={<Input style={{ ...customInputStyle }}/>}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="bankName"
                    render={({ message }) => (
                      <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                    )}
                  />
                  <LabelText style={{ color: 'black' }}>Account Type</LabelText>
                  <Controller
                    defaultValue={""}
                    color={errors.accountType ? "red" : "inherit"}
                    marginBottom="0px"
                    control={control}
                    name="accountType"
                    placeholder="select"
                    rules={{
                      required: 'Account type is required'
                    }}
                    as={<Select
                      className="px-0 border-0"
                      getOptionLabel={(option) => option.value}
                      styles={selectCustomStyles}
                      options={alpha2 === "IN" ? INDIA_ACCOUNT_TYPES.map(value => { return { value } }) : ACCOUNT_TYPES.map(value => { return { value } })} />}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="accountType"
                    render={({ message }) => (
                      <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                    )}
                  />
                  <LabelText style={{ color: 'black' }}>Account Holder Name</LabelText>
                  <Controller
                    defaultValue={""}
                    color={errors.accountHolderName ? "red" : "inherit"}
                    marginBottom="0px"
                    control={control}
                    name="accountHolderName"
                    placeholder="Enter account holder name"
                    rules={{
                      required: 'This field is required',
                      pattern: {
                        value: /^[a-zA-Z ]+$/,
                        message: 'Bank Holder name must be valid',
                      },
                    }}
                    as={<Input style={{ ...customInputStyle }} />}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="accountHolderName"
                    render={({ message }) => (
                      <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                    )}
                  />
                  <LabelText style={{ color: 'black' }}>Bank Account Number</LabelText>
                  <Controller
                    defaultValue={""}
                    color={errors.accountNumber ? "red" : "inherit"}
                    marginBottom="0px"
                    control={control}
                    name="accountNumber"
                    placeholder="Enter account number"
                    rules={{
                      required: 'This field is required',
                      pattern: {
                        value: /^\s*[0-9]{6,17}\s*$/,
                        message: 'The account number is invalid',
                      },
                    }}
                    as={<Input style={{ ...customInputStyle }} />}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="accountNumber"
                    render={({ message }) => (
                      <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                    )}
                  />
                  {
                    alpha2 === "IN" ? (
                      <>
                        <LabelText style={{ color: 'black' }}>IFSC Code</LabelText>
                        <Controller
                          defaultValue={""}
                          color={errors.routingNumber ? "red" : "inherit"}
                          marginBottom="0px"
                          control={control}
                          name="routingNumber"
                          placeholder="Enter IFSC Code"
                          rules={customerValidation && {
                            required: 'This field is required',
                            pattern: {
                              value: /^[A-Za-z]{4}0[A-Z0-9a-z]{6}$/,
                              message: 'The IFSC Code is invalid',
                            },
                          }}
                          as={<Input style={{ ...customInputStyle }} />}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="routingNumber"
                          render={({ message }) => (
                            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                          )}
                        />
                      </>

                    ) : (
                      <>
                        <LabelText style={{ color: 'black' }}>
                         {preFillCustomer?.address?.country?.alpha2 === 'IN' ? 'IFSC Code' : 'Routing Number'} 
                        </LabelText>
                        <Controller
                          defaultValue={""}
                          color={errors.routingNumber ? "red" : "inherit"}
                          marginBottom="0px"
                          control={control}
                          name="routingNumber"
                          placeholder={preFillCustomer?.address?.country?.alpha2 === 'IN' ? "Enter IFSC Code" : "Enter routing number"}
                          rules={customerValidation && preFillCustomer?.address?.country?.alpha2 !== 'IN' && {
                            required: 'This field is required',
                            pattern: {
                              value: /^\s*[0-9]{9}\s*$/,
                              message: 'The routing number is invalid',
                            },
                          }}
                          as={<Input style={{ ...customInputStyle }} />}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="routingNumber"
                          render={({ message }) => (
                            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                          )}
                        />
                      </>
                    )
                  }
                </>
              )
              : null
            }
            <LabelText style={{ color: 'black' }}>
              Business Type
            </LabelText>
            <Controller
              defaultValue={""}
              color={errors.businessType ? "red" : "inherit"}
              marginBottom="0px"
              control={control}
              name="businessType"
              placeholder="select"
              rules={{
                required: 'Business type is required'
              }}
              as={<Select
                className="px-0 border-0"
                getOptionLabel={(option) => option.value}
                styles={selectCustomStyles}
                options={BUSINESS_TYPES_FUNDINGlINK.map(value => { return { value } }) } />}
            />
            <ErrorMessage
              errors={errors}
              name="businessType"
              render={({ message }) => (
                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
              )}
            />
            <div className="mt-4">
              <label>
                <Controller
                  marginBottom="0px" 
                  name='isDefault' 
                  control={control} 
                  render={({ field }) => (
                    <Input
                      type="checkbox"
                      width="auto"
                      onChange={(e) => setValue('isDefault', e.target.checked)}
                    />
                  )}
                />
                <SpanText className="pl-2">Set as default bank account</SpanText>
              </label>
            </div>
            <div className="px-1 px-md-4">
              <FlexContainer
                width="100%"
                alignItems="center"
                justifyContent="space-between"
              >
                {
                  showCancelButton && cancel &&
                  <SpanText
                    onClick={onCancel}
                    cursor="pointer"
                    color="#40A9FF"
                    className="cursor-pointer m-3 pt-3"
                  >{cancelButtonText || "Cancel"}</SpanText>
                }
                {disableButtonText && (planStartDate < currentDateObject) ?
                  (
                    <SubmitButton
                      type="submit"
                      disabled
                    >{buttonText || "PAY"}</SubmitButton>
                  )
                  : (
                    <SubmitButton
                      type="submit"
                      disabled={buttonDisabled}
                    >{buttonText || "PAY"}</SubmitButton>
                  )
                }
              </FlexContainer>
              {/* {isShowErrorMessage && <PaymentError header={errorHeader} message={errorMsg} />} */}
              {(disableButtonText && (planStartDate < currentDateObject)) && <PaymentError header={disableButtonText} message={'For more information, please contact support@swirepay.com'} />}
            </div>
          </div>
        </FlexContainer>
      </form>
    </>
  )
};

export default FundingLink;
